<script setup lang="ts">
import {
  useBrowserStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppBasePlaceholder } from '@libs/ui';

import type { ItineraryOwnStaySegment } from '../../../models/itinerarySegments/ownStay';
import ItineraryTimeline from '../ItineraryTimeline.vue';
import { useTripOverviewPageStore } from '../../../stores';
import { AppPlaceholderEventType } from '../../../models';

const { t } = i18n.global;

interface ItineraryOwnStaySegmentProps {
  segment: ItineraryOwnStaySegment;
  isLoading?: boolean;
  printMode?: boolean;
}
const props = defineProps<ItineraryOwnStaySegmentProps>();

const statsigEventsStore = useStatsigEventsStore();
const tripOverviewPageStore = useTripOverviewPageStore();
const browserStore = useBrowserStore();

function toggleAccommodation(): void {
  const isDisabled = true;
  statsigEventsStore.logTripOverviewHotelToggle(isDisabled);

  tripOverviewPageStore.addAccommodationToOwnStayIngredient(
    props.segment.context.ingredientId
  );
}
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="itinerary-own-stay-segment"
  >
    <template #banner>
      <AppBasePlaceholder
        class="accommodation-placeholder"
        :title="t('overview_placeholder.accommodation.title')"
        :description="t('overview_placeholder.accommodation.description')"
        :is-small-device="browserStore.isSmallerThan900px"
        :icon-properties="{
          name: 'accommodation',
          color: 'color-brand-violet',
        }"
        :actions="[
          {
            textToDisplay: t('placeholder.add_hotel'),
            eventType: AppPlaceholderEventType.AddHotel,
          },
        ]"
        :is-loading="props.isLoading"
        :is-print-mode="props.printMode"
        @action-clicked="toggleAccommodation"
      />
    </template>
  </ItineraryTimeline>
</template>

<style scoped lang="scss">
.accommodation-placeholder {
  @include for-less-or-equal-than-1199-px {
    margin-left: var(--spacing-8);
  }
  @include for-less-or-equal-than-599-px {
    margin-left: 0;
  }
}
</style>
